import React from 'react';
import Icon from '../../../components/AppIcon';

const steps = [
  { icon: 'CreditCard', label: 'Purchase with SocialCents Card', color: '#14B8A6' },
  { icon: 'ScanLine', label: 'Purchase Auto-Detected', color: '#3B82F6' },
  { icon: 'Share2', label: 'Post on Social Media', color: '#8B5CF6' },
  { icon: 'Wallet', label: 'Cashback Credited to Wallet', color: '#10B981' }
];

const WalletFlowPreview = () => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold text-foreground">How It Works</h2>
        <p className="text-muted-foreground text-sm mt-1">Your complete purchase-to-cashback journey</p>
      </div>
      <div
        className="rounded-2xl p-6"
        style={{ background: 'rgba(20, 184, 166, 0.04)', border: '1px solid rgba(20, 184, 166, 0.12)' }}
      >
        {/* Desktop: horizontal flow */}
        <div className="hidden md:flex items-center justify-between gap-2">
          {steps?.map((step, i) => (
            <React.Fragment key={i}>
              <div className="flex flex-col items-center gap-3 flex-1">
                <div
                  className="w-12 h-12 rounded-2xl flex items-center justify-center"
                  style={{ background: `${step?.color}15`, border: `1px solid ${step?.color}30` }}
                >
                  <Icon name={step?.icon} size={20} style={{ color: step?.color }} />
                </div>
                <p className="text-xs text-center text-muted-foreground leading-snug max-w-[90px]">{step?.label}</p>
              </div>
              {i < steps?.length - 1 && (
                <div className="flex items-center flex-shrink-0 -mt-6">
                  <div className="w-8 h-px" style={{ background: 'linear-gradient(90deg, rgba(20,184,166,0.4), rgba(59,130,246,0.4))' }} />
                  <Icon name="ChevronRight" size={14} className="text-muted-foreground -ml-1" />
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Mobile: vertical flow */}
        <div className="flex flex-col gap-4 md:hidden">
          {steps?.map((step, i) => (
            <div key={i} className="flex items-center gap-4">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: `${step?.color}15`, border: `1px solid ${step?.color}30` }}
              >
                <Icon name={step?.icon} size={18} style={{ color: step?.color }} />
              </div>
              <div className="flex-1">
                <p className="text-sm text-foreground font-medium">{step?.label}</p>
              </div>
              {i < steps?.length - 1 && (
                <div className="absolute left-9 mt-10 w-px h-4 bg-border" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WalletFlowPreview;
